import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-failure-popup',
  templateUrl: './failure-popup.component.html',
  styleUrls: ['./failure-popup.component.scss'],
})
export class FailurePopupComponent {
  constructor(
    public dialogRef: MatDialogRef<FailurePopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      header: string;
      failureMessage: string;
      showClose?: boolean;
    },
  ) {}
}
